import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=5f72e89e&scoped=true&"
import script from "./paginator.vue?vue&type=script&lang=js&"
export * from "./paginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72e89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danzimney/Development/Projects/org-edreports/src/main/websrc/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f72e89e')) {
      api.createRecord('5f72e89e', component.options)
    } else {
      api.reload('5f72e89e', component.options)
    }
    module.hot.accept("./paginator.vue?vue&type=template&id=5f72e89e&scoped=true&", function () {
      api.rerender('5f72e89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paginator.vue"
export default component.exports